import Flickity from 'flickity'
import './locaties.scss'

document.addEventListener('DOMContentLoaded', () => {
    const locationFilter = document.getElementById('location_type');
    const countryFilter = document.getElementById('country');

    const locationCarousel = document.getElementById('locations-flickity');

    if (!locationCarousel) return;

    const waitForClass = (element, className, timeout = 5000) => new Promise(resolve => {
        if (!element) return resolve(false);
        if (element.classList.contains(className)) return resolve(true);

        const observer = new MutationObserver((mutations, obs) => {
            if (element.classList.contains(className)) {
                obs.disconnect();
                resolve(true);
            }
        });

        observer.observe(element, { attributes: true, attributeFilter: ['class'] });

        setTimeout(() => {
            observer.disconnect();
            resolve(false);
        }, timeout);
    });

    const resizeCarousel = () => {
        if (!locationCarousel) {
            return;
        }

        const flkty = Flickity.data(locationCarousel);
        if (flkty) {
            flkty.resize();
        }
    };

    waitForClass(locationCarousel, 'flickity-enabled').then(isReady => {
        if (isReady) {
            resizeCarousel();
        }
    });

    function updateVisibleCards() {
        const cards = locationCarousel.querySelectorAll('.o-locaties__card');
        const hiddenCard = locationCarousel.querySelector('.o-locaties__card[data-hidden]');
        const selectedType = locationFilter ? locationFilter.value : '';
        const selectedCountry = countryFilter ? countryFilter.value : '';

        cards.forEach(card => {
            const typeValues = (card.getAttribute('data-type') || '').split(',').map(v => v.trim());
            const countryValues = (card.getAttribute('data-country') || '').split(',').map(v => v.trim());

            const matchesType = selectedType === '' || typeValues.includes(selectedType);
            const matchesCountry = selectedCountry === '' || countryValues.includes(selectedCountry);

            if (matchesType && matchesCountry) {
                card.style.display = '';
            } else {
                card.style.display = 'none';
            }
        });

        setTimeout(() => {
            resizeCarousel();
        }, 100);

        // counter for visible cards
        const visibleCards = Array.from(cards).filter(card => card.style.display !== 'none').length;
        if (hiddenCard && visibleCards === 0) {
            hiddenCard.style.display = '';
            locationCarousel.dataset.counter = '0';
        } else if (hiddenCard) {
            hiddenCard.style.display = 'none';
            locationCarousel.dataset.counter = visibleCards.toString();
        } else {
            locationCarousel.dataset.counter = visibleCards.toString();
        }
    }

    if (locationFilter) {
        locationFilter.addEventListener('change', () => {
            updateVisibleCards();
        });
    }

    if (countryFilter) {
        countryFilter.addEventListener('change', () => {
            updateVisibleCards();
        });
    }
});